var buildEnv = process.env.NODE_ENV
var data: any;

class DANH_MUC_TEST {

    // test Tiếng anh
    static readonly GALLERY_HINH_ANH_VUI_HOC = 558;
    static readonly GALLERY_HOAT_DONG_SU_KIEN = 559;
    static readonly GALLERY_THAM_QUAN_DA_NGOAI = 560;
    static readonly HOAT_DONG_VUI_HOC = 561;
    static readonly TUYEN_SINH = 563;
    static readonly LICH_SU_KIEN = 562;
    static readonly VIDEO = 556;
    static readonly MEGESTORY = 637;
    static readonly LANDINGPAGE = 665;
    static readonly TUYEN_DUNG = 679;

    static readonly HINH_ANH_MAM_NON_HĐVH = 558;
    static readonly HINH_ANH_MAM_NON_THAM_QUAN = 560;
    static readonly HINH_ANH_MAM_NON_SU_KIEN = 559;
    static readonly HINH_ANH_PHO_THONG_HĐVH = 658;
    static readonly HINH_ANH_PHO_THONG_THAM_QUAN = 659;
    static readonly HINH_ANH_PHO_THONG_SU_KIEN = 660;
    static readonly VIDEO_HĐVH = 662;
    static readonly VIDEO_THAM_QUAN = 663;
    static readonly VIDEO_SU_KIEN = 664;

    static readonly CTH_SONG_NGU = 394;
    static readonly CTH_HOI_NHAP = 393;
    static readonly CTH_SUMMER_CAMP = 467;
    static readonly COSOPMH = 'Cơ sở Phú Mỹ Hưng';
    static readonly COSOPL = 'Cơ sở Phú Lâm';
}

class DANH_MUC_RELEASE {
    // release Tiếng anh
    static readonly GALLERY_HINH_ANH_VUI_HOC = 463;
    static readonly GALLERY_HOAT_DONG_SU_KIEN = 461;
    static readonly GALLERY_THAM_QUAN_DA_NGOAI = 462;
    static readonly HOAT_DONG_VUI_HOC = 454;
    static readonly TUYEN_SINH = 456;
    static readonly LICH_SU_KIEN = 455;
    static readonly VIDEO = 460;
    static readonly MEGESTORY = 531;
    static readonly LANDINGPAGE = 530;
    static readonly TUYEN_DUNG = 564;

    static readonly HINH_ANH_MAM_NON_HĐVH = 463;
    static readonly HINH_ANH_MAM_NON_THAM_QUAN = 462;
    static readonly HINH_ANH_MAM_NON_SU_KIEN = 461;
    static readonly HINH_ANH_PHO_THONG_HĐVH = 535;
    static readonly HINH_ANH_PHO_THONG_THAM_QUAN = 536;
    static readonly HINH_ANH_PHO_THONG_SU_KIEN = 537;
    static readonly VIDEO_HĐVH = 538;
    static readonly VIDEO_THAM_QUAN = 539;
    static readonly VIDEO_SU_KIEN = 540;

    static readonly CTH_SONG_NGU = 394;
    static readonly CTH_HOI_NHAP = 393;
    static readonly CTH_SUMMER_CAMP = 467;
    static readonly COSOPMH = 'Cơ sở Phú Mỹ Hưng';
    static readonly COSOPL = 'Cơ sở Phú Lâm';
}

if (buildEnv === 'production') {
    data = DANH_MUC_RELEASE;
} else {
    data = DANH_MUC_TEST;
}

export class DANH_MUC {
    static readonly GALLERY_HINH_ANH_VUI_HOC = data.GALLERY_HINH_ANH_VUI_HOC;
    static readonly GALLERY_HOAT_DONG_SU_KIEN = data.GALLERY_HOAT_DONG_SU_KIEN;
    static readonly GALLERY_THAM_QUAN_DA_NGOAI = data.GALLERY_THAM_QUAN_DA_NGOAI;
    static readonly HOAT_DONG_VUI_HOC = data.HOAT_DONG_VUI_HOC;
    static readonly TUYEN_SINH = data.TUYEN_SINH;
    static readonly LICH_SU_KIEN = data.LICH_SU_KIEN;
    static readonly VIDEO = data.VIDEO;
    static readonly MEGESTORY = data.MEGESTORY;
    static readonly LANDINGPAGE = data.LANDINGPAGE;
    static readonly TUYEN_DUNG = data.TUYEN_DUNG;

    static readonly HINH_ANH_MAM_NON_HĐVH = data.HINH_ANH_MAM_NON_HĐVH;
    static readonly HINH_ANH_MAM_NON_THAM_QUAN = data.HINH_ANH_MAM_NON_THAM_QUAN;
    static readonly HINH_ANH_MAM_NON_SU_KIEN = data.HINH_ANH_MAM_NON_SU_KIEN;
    static readonly HINH_ANH_PHO_THONG_HĐVH = data.HINH_ANH_PHO_THONG_HĐVH;
    static readonly HINH_ANH_PHO_THONG_THAM_QUAN = data.HINH_ANH_PHO_THONG_THAM_QUAN;
    static readonly HINH_ANH_PHO_THONG_SU_KIEN = data.HINH_ANH_PHO_THONG_SU_KIEN;
    static readonly VIDEO_HĐVH = data.VIDEO_HĐVH;
    static readonly VIDEO_THAM_QUAN = data.VIDEO_THAM_QUAN;
    static readonly VIDEO_SU_KIEN = data.VIDEO_SU_KIEN;

    static readonly CTH_SONG_NGU = data.CTH_SONG_NGU;
    static readonly CTH_HOI_NHAP = data.CTH_HOI_NHAP;
    static readonly CTH_SUMMER_CAMP = data.CTH_SUMMER_CAMP;
    static readonly COSOPMH = data.COSOPMH;
    static readonly COSOPL = data.COSOPL;
}